import type { EmberChangeset } from 'ember-changeset';
import t from 'ember-intl/helpers/t';
import FeelingEvasSectionContent from 'parog-web/components/feeling-evas/sliders/component';
import type ForcJournalEventBasedComponent from 'parog-web/components/forc/abstract/journal-event-based-component';
import Slider from 'parog-web/components/mici/base-consult-form/slider';

interface Signature {
  Args: {
    form: { changeset: EmberChangeset };
    forcComponent: ForcJournalEventBasedComponent;
  };
}

export default class extends FeelingEvasSectionContent<Signature> {
  <template>
    {{#if @forcComponent.changeset.immediateStool}}
      <Slider
        @form={{@form}}
        @forcComponent={{@forcComponent}}
        @key='immediateStoolUrgency'
      >
        <:header>
          <div>
            <div class='text-black'>{{t
                'mici-form.immediateStoolUrgency.long'
                htmlSafe=true
              }}</div>
          </div>
        </:header>
        <:lowest>
          Aucune urgence (0)
        </:lowest>
        <:highest>
          Urgence maximale imaginable (10)
        </:highest>
      </Slider>
    {{/if}}
  </template>
}
